import { render, staticRenderFns } from "./investimentoTR.vue?vue&type=template&id=98ad1d90&"
import script from "./investimentoTR.vue?vue&type=script&lang=js&"
export * from "./investimentoTR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports